import styles from './InputText.module.css';

export default function InputText({ name, label, value, onChange, placeholder, type = "text", error, onFocus, onBlur, onKeyDown, maxLength, min, className }) {
    return (
        <div className={`${styles.inputContainer} ${className || ''}`}>
            <label className={styles.label} htmlFor={name}>{label}</label>
            <input
                name={name}
                className={`${styles.input} ${error ? styles.errorInput : ''} ${!value ? styles.placeholder : ''}`}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                maxLength={maxLength}
                min={min}
            />
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
}